import { alpha, createTheme } from '@mui/material/styles';

export const createAppTheme = (brandPrimary: string) => createTheme({
  palette: {
    primary: { main: brandPrimary, dark: '#7568cf', light: '#efedfc' },
    secondary: { main: '#007a7e', dark: '#005f62', light: '#e6f4f4' },
    background: { default: '#f7f8fb', paper: '#ffffff' },
    text: { primary: '#23232d', secondary: '#68697a' },
    divider: '#e6e7ed',
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: "'Mulish', sans-serif",
    h4: { fontSize: '1.75rem', fontWeight: 700 },
    h5: { fontSize: '1.35rem', fontWeight: 700 },
    h6: { fontSize: '1rem', fontWeight: 700 },
    button: { fontWeight: 700, textTransform: 'none' },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { minHeight: 40, boxShadow: 'none', transition: 'background-color 180ms ease, box-shadow 180ms ease' },
      },
      defaultProps: { disableElevation: true },
    },
    MuiIconButton: {
      styleOverrides: { root: { transition: 'background-color 180ms ease, color 180ms ease' } },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: 'none' } },
    },
    MuiCard: {
      styleOverrides: {
        root: { border: '1px solid #e6e7ed', boxShadow: '0 8px 24px rgba(35, 35, 45, 0.05)' },
      },
    },
    MuiTableHead: {
      styleOverrides: { root: { backgroundColor: '#f5f5f9' } },
    },
    MuiTableRow: {
      styleOverrides: { root: { transition: 'background-color 160ms ease' } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: alpha(brandPrimary, 0.65) },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: { margin: 0 },
        '*': { boxSizing: 'border-box' },
        '::selection': { backgroundColor: alpha(brandPrimary, 0.2) },
        '@media (prefers-reduced-motion: reduce)': {
          '*, *::before, *::after': { animationDuration: '0.01ms !important', transitionDuration: '0.01ms !important' },
        },
      },
    },
  },
});
